export const SITE = "https://pame3d.com";
export const BRAND = "Pame3D";
export const OG_IMAGE = `${SITE}/img/og.jpg`;

export const abs = (p) => (!p ? OG_IMAGE : p.startsWith("http") ? p : `${SITE}${p}`);
export const urlSlug = (slug) => slug.replace(/_/g, "-");
export const clip = (s, n) => (s.length <= n ? s : s.slice(0, n - 1).replace(/\s+\S*$/, "") + "…");

export const PAGES = {
  home: {
    path: "/",
    title: "Pame3D | Impresión 3D sostenible en Barranquilla",
    description: "Juguetes educativos, figuras personalizadas y regalos impresos en 3D con botellas PET recicladas. Envíos en Barranquilla y toda Colombia.",
    h1: "Cada producto nace de una botella.",
  },
  catalogo: {
    path: "/catalogo",
    title: "Catálogo de juguetes y regalos 3D reciclados | Pame3D",
    description: "Kits educativos de animales, juegos de mesa, motricidad fina, figuras personalizadas y decoración impresa en 3D con plástico reciclado. Compra en línea.",
    h1: "Catálogo de diseños",
  },
  disena: {
    path: "/disena",
    title: "Impresión 3D personalizada en Barranquilla | Pame3D",
    description: "Cuéntanos tu idea y la hacemos realidad en 3D con material reciclado: figuras, regalos, repuestos y prototipos. Cotización en 24 a 48 horas.",
    h1: "Diseña lo tuyo",
  },
  proceso: {
    path: "/proceso",
    title: "De botella PET a filamento: nuestro proceso | Pame3D",
    description: "Así transformamos botellas recicladas en filamento rPET e impresión 3D: recolección, corte en tiras, secado, pultrusión e impresión capa por capa.",
    h1: "Nuestro proceso",
  },
  tablero: {
    path: "/tablero",
    title: "Tablero digital: arma figuras en pantalla | Pame3D",
    description: "Juega en línea con el tablero de construcción Pame3D: elige fichas, gíralas y copia más de 60 figuras: letras, números, dinosaurios y más. Gratis.",
    h1: "Tablero digital",
    image: `${SITE}/img/tablero_pame3d.jpg`,
  },
  hamburguesa: {
    path: "/hamburguesa",
    title: "Hamburguesa para armar: juego digital | Pame3D",
    description: "Arma en pantalla los 8 menús de la hamburguesa impresa en 3D de Pame3D: apila pan, carne, queso, tomate y lechuga en el orden correcto. Gratis para niños.",
    h1: "Hamburguesa digital",
    image: `${SITE}/img/hamburguesa_armar.jpg`,
  },
  pizza: {
    path: "/pizza",
    title: "Pizza enroscable: juego digital | Pame3D",
    description: "Prepara en pantalla los 7 momentos de la pizza enroscable de Pame3D: cuenta pepperonis, quesos y piñas y ponlos en cada porción. Juego gratis para niños.",
    h1: "Pizza digital",
    image: `${SITE}/img/pizza_enroscable.jpg`,
  },
  retos: {
    path: "/retos",
    title: "Retos del tablero: 12 misiones con tiempo | Pame3D",
    description: "Los 12 retos de las tarjetas del tablero Pame3D en versión digital: torre más alta, puente, espejo, memoria y más, con temporizador y estrellas. Gratis.",
    h1: "Retos del tablero",
    image: `${SITE}/img/tablero_pame3d.jpg`,
  },
  galeria: {
    path: "/galeria",
    title: "Galería de creaciones de los niños | Pame3D",
    description: "Figuras, hamburguesas y pizzas creadas por niños en los juegos digitales de Pame3D. Guarda la tuya con tu nombre y compártela con tu familia.",
    h1: "Galería de creaciones",
  },
  contacto: {
    path: "/contacto",
    title: "Contacto: impresión 3D en Barranquilla | Pame3D",
    description: "Escríbenos por WhatsApp, Instagram @pame.3d o correo. Impresión 3D sostenible en Barranquilla, Atlántico, con envíos a toda Colombia.",
    h1: "Contacto",
  },
};

export const FAQ = [
  { q: "¿Hacen envíos en Barranquilla?",
    a: "Sí. Enviamos a Barranquilla y a toda Colombia. El envío tiene un costo de $11.000 COP y tarda aproximadamente 5 días hábiles desde que despachamos tu pedido. Te confirmamos la guía por WhatsApp." },
  { q: "¿Cuánto tarda mi pedido?",
    a: "Los productos del catálogo se imprimen bajo pedido en 3 a 5 días hábiles; después, el envío tarda alrededor de 5 días hábiles ($11.000 COP). Los encargos personalizados toman entre 5 y 10 días hábiles de producción según su complejidad; te confirmamos la fecha en la cotización." },
  { q: "¿De qué materiales están hechos los productos?",
    a: "Usamos filamento rPET fabricado por nosotros a partir de botellas recicladas y, cuando la pieza lo requiere (juegos y kits infantiles), PETG o PLA. Son materiales resistentes, sin BPA y se lavan con agua y jabón." },
  { q: "¿Puedo pedir un diseño personalizado?",
    a: "Claro. Hacemos figuras a partir de fotos, letreros, repuestos, prototipos y regalos corporativos. Entra a “Diseña lo tuyo”, describe tu idea, adjunta referencias y te enviamos una cotización en 24 a 48 horas." },
  { q: "¿Cómo puedo pagar?",
    a: "Con tarjeta de crédito o débito a través de Stripe, en pesos colombianos o dólares. Para encargos personalizados te enviamos un enlace de pago seguro cuando apruebes la cotización." },
  { q: "¿Los juguetes son seguros para niños?",
    a: "Sí. Las piezas son sólidas, sin bordes filosos y pensadas para manos pequeñas; los recomendamos a partir de 3 años con acompañamiento de un adulto. Los juegos incluyen tarjetas de actividades que puedes consultar en pame3d.com/juegos." },
];

export const LOCAL_BUSINESS = {
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "Store"],
  "@id": `${SITE}/#negocio`,
  name: "Pame3D · Miss Pam Transforma",
  alternateName: ["Pame3D", "Miss Pam Transforma"],
  description: "Taller de impresión 3D sostenible en Barranquilla: convertimos botellas PET recicladas en filamento y en juguetes educativos, figuras personalizadas, juegos de mesa y objetos para el hogar.",
  url: SITE,
  image: OG_IMAGE,
  logo: OG_IMAGE,
  telephone: "+573106846758",
  email: "pamelamg98@gmail.com",
  priceRange: "$15.000 - $290.000 COP",
  currenciesAccepted: "COP, USD",
  paymentAccepted: "Tarjeta de crédito, Tarjeta débito",
  address: { "@type": "PostalAddress", addressLocality: "Barranquilla", addressRegion: "Atlántico", addressCountry: "CO" },
  areaServed: [
    { "@type": "City", name: "Barranquilla" },
    { "@type": "AdministrativeArea", name: "Atlántico" },
    { "@type": "Country", name: "Colombia" },
  ],
  sameAs: ["https://instagram.com/pame.3d"],
  knowsAbout: ["Impresión 3D", "Reciclaje de botellas PET", "Filamento rPET", "Juguetes educativos", "Regalos personalizados"],
};

export const breadcrumb = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE}${path}` })),
});

export const faqSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
});

export const productSeo = (p) => {
  const path = `/catalogo/${urlSlug(p.slug)}`;
  const offers = p.price_cop != null
    ? { "@type": "Offer", price: p.price_cop, priceCurrency: "COP", availability: "https://schema.org/InStock",
        url: `${SITE}${path}`, itemCondition: "https://schema.org/NewCondition", priceValidUntil: "2027-12-31",
        shippingDetails: { "@type": "OfferShippingDetails", shippingDestination: { "@type": "DefinedRegion", addressCountry: "CO" } } }
    : undefined;
  return {
    path,
    title: clip(p.name_es.includes(BRAND) ? `${p.name_es} | Juego 3D` : `${p.name_es} | ${BRAND}`, 60),
    description: clip(p.desc_es || `${p.name_es} impreso en 3D con material reciclado en Barranquilla.`, 155),
    image: abs(p.image),
    h1: p.name_es,
    jsonld: [
      { "@context": "https://schema.org", "@type": "Product", name: p.name_es, description: p.desc_es, image: [abs(p.image)],
        sku: p.slug, brand: { "@type": "Brand", name: BRAND }, material: p.material, color: (p.colors || []).join(", "),
        url: `${SITE}${path}`, ...(offers ? { offers } : {}) },
      breadcrumb([["Inicio", "/"], ["Catálogo", "/catalogo"], [p.name_es, path]]),
    ],
  };
};

export const pageJsonld = (key) => {
  const p = PAGES[key];
  const crumbs = key === "home" ? [["Inicio", "/"]] : [["Inicio", "/"], [p.h1, p.path]];
  const out = [breadcrumb(crumbs)];
  if (key === "home") out.push(faqSchema());
  return out;
};
